import * as API from './api';

const SkillbuilderModel = { ...API };

export default SkillbuilderModel;
